module.exports = __webpack_public_path__ + "img/example-tag.81589ad5.jpg";